var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticStyle:{"height":"330px"},attrs:{"border-variant":"dark"}},[_c('h6',[_vm._v("Ocupação de Agentes")]),_vm._v(" "),_c('div',{attrs:{"id":"chart2"}},[_c('apexchart',{attrs:{"type":"bar","height":"280","options":_vm.chartOptions,"series":_vm.series}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }